import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventTags = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['tags'] => getEvent(eventKey)(store).tags;
